<template>
  <transition :name="transition">
    <div v-if="model" class="gk-modal" :class="{ 'gk-modal--loading': loading }">
      <div class="gk-modal__overlay" @click="close"></div>
      <div class="gk-modal__container">
        <span class="btn-close" @click="close"></span>
        <div class="gk-modal__content">
          <slot></slot>
        </div>
        <div class="gk-modal__footer">
          <slot name="footer"></slot>
        </div>
      </div>
      <div v-if="loading" class="gk-modal__loading">
        Loading...
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'gkModal',
  props: {
    model: {
      type: Boolean,
      required: true
    },
    transition: {
      type: String,
      default: 'gk-fade-up'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:model', 'destroy'],
  methods: {
    close() {
      this.$emit('update:model', false);
      this.$emit('destroy');
    }
  }
}
</script>

<style lang="scss" scoped>
.gk-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.gk-modal__overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}

.gk-modal__container {
  box-sizing: border-box;
  position: relative;
  z-index: 20000;
  background: #fff;
  border-radius: 4px;
  -webkit-transition: all .3s ease;
  transition: all .3s ease;
  pointer-events: all;
  width: 800px;
  max-height: 85vh;
  text-align: center;
  background-color: transparent;
  @include mobile {
    width: calc(100vw - 20px);
    padding: 0;
    max-height: 94dvh;
    border-radius: 12px;
    overflow: hidden;
  }
  .btn-close {
    position: absolute;
    top: 2px;
    right: 10px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    z-index: 9;
    @include mobile {
      right: 10px;
      top: 12px;
    }
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 20px;
      height: 2px;
      margin-left: -10px;
      background: #8a8a8a;
      border-radius: 2px;
      -webkit-transform-origin: center;
      transform-origin: center;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      width: 20px;
      height: 2px;
      margin-left: -10px;
      background: #8a8a8a;
      border-radius: 2px;
      -webkit-transform-origin: center;
      transform-origin: center;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
  }
  .gk-modal__content {
    min-height: 70vh;
    max-height: 80vh;
    overflow: auto;
    @include mobile {
      min-height: 0;
      max-height: 94dvh;
      overflow: auto;
    }
    video {
      display: block;
      width: 100%;
      height: 100%;    
      border-radius: 4px;
    }
  }
}

.gk-modal__loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 4px;
}

/* Transition styles */
.gk-fade-up-enter-active,
.gk-fade-up-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.gk-fade-up-enter-from,
.gk-fade-up-leave-to {
  opacity: 0;
  transform: translateY(20px);
}
</style>
